import script from "./IconCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./IconCheckbox.vue?vue&type=style&index=0&id=3ce6dab7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ce6dab7"]])

export default __exports__